import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import {
  fetchVehicleModel,
  initializeVehicleModelScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleModel,
  saveVehicleModelTableState
} from "../../../redux/actions/vehicles/vehicleModel";
import VehicleModel from '../../../component/Vehicles/VehicleModel';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleModelScreen(props) {
  const {
    fetchVehicleModel,
    initVehicleModelScreen,
    showPageLevelLoader,
    vehicleModelListview,
    paginationInfo,
    screenPermissions,
    exportVehicleModel,
    isVehicleModelExportError,
    isVehicleModelExportSuccess,
    isLoading,
    savedTableState,
    saveVehicleModelTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleModelScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleModel(savedParams);
    } else {
      fetchVehicleModel({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleModel(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleModelTableState(tableState);
  };
  const handleCreateVehicleModel = () => {
    navigate(APP_URLS.VEHICLE_MODEL.CREATE);
  }
  const editVehicleModelRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_MODEL.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleModel = {
    handleCreateVehicleModel,
    exportVehicleModel,
    isVehicleModelExportError,
    isVehicleModelExportSuccess,
    editVehicleModelRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchVehicleModels: loadLazyData,
    tableData: {
      columns: vehicleModelListview?.columns,
      rows: vehicleModelListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleModel
        {...vehicleModel}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleModelScreen: () => dispatch(initializeVehicleModelScreen()),
    fetchVehicleModel: (payload) => dispatch(fetchVehicleModel(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleModel: (payload) => dispatch(exportVehicleModel(payload)),
    saveVehicleModelTableState: (payload) => dispatch(saveVehicleModelTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleModelCreateSuccess: selectFromVehicleModelReducer(
      state,
      "isVehicleModelCreateSuccess"
    ),
    vehicleModelListview: selectFromVehicleModelReducer(
      state,
      "vehicleModelListview"
    ),
    showPageLevelLoader: selectFromVehicleModelReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleModelReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleModelReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleModelReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleModelExportError: selectFromVehicleModelReducer(
      state,
      "isVehicleModelExportError"
    ),
    isVehicleModelExportSuccess: selectFromVehicleModelReducer(
      state,
      "isVehicleModelExportSuccess"
    ),
    savedTableState: selectFromVehicleModelReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleModelReducer = (state, path) => {
  return selectVehicleModelReducer(state)[path];
};

const selectVehicleModelReducer = ({ vehicleModelReducer }) => {
  return vehicleModelReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleModelScreen);
